import { Component, OnInit } from '@angular/core';
import { GestockService } from '../services/gestock.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-caisse',
  templateUrl: './caisse.component.html',
  styleUrls: ['./caisse.component.css']
})
export class CaisseComponent implements OnInit {

  samacaabiyoonwii: any;
  profil: string = '';
  isReadOnly: boolean = false;
  isCaissier: boolean = false;
  boutiques: any[] = [];
  selectedBoutique: any = null;
  solde: number = 0;
  caisseType: string = 'Automatique';
  nbEnAttente: number = 0;
  totalEnAttente: number = 0;

  transactions: any[] = [];
  statutFilter: string = 'tous'; // 'tous', 'validee', 'en_attente', 'rejetee'
  datedeb: Date;
  datefin: Date;
  
  nouvelleTransaction = {
    type_transaction: 'entree',
    montant: 0,
    motif: ''
  };

  constructor(private gestockService: GestockService) {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    this.profil = sessionStorage.getItem("profil") || '';
    this.isReadOnly = this.profil === 'ADMINISTRATEUR' || this.profil === 'Contrôleur de Gestion';
    this.isCaissier = this.profil.toLowerCase() === 'caissier' || this.profil.toLowerCase() === 'caisse';
    this.datedeb = new Date(new Date().setDate(new Date().getDate() - 30));
    this.datefin = new Date();
  }

  ngOnInit(): void {
    if (this.isReadOnly) {
      this.gestockService.getAllPoints(this.samacaabiyoonwii).then(res => {
        if(res.statutreq == 1) {
          this.boutiques = res.data;
          if (this.boutiques && this.boutiques.length > 0) {
            this.selectedBoutique = this.boutiques[0].idPoint;
            this.loadData();
          }
        }
      });
    } else {
      this.loadData();
    }
  }

  loadData() {
    const start = formatDate(this.datedeb, 'yyyy-MM-dd', 'en-US');
    const end = formatDate(this.datefin, 'yyyy-MM-dd', 'en-US');
    const payload = {
      date_debut: start,
      date_fin: end,
      ...(this.selectedBoutique ? { idboutique: this.selectedBoutique } : {})
    };

    this.gestockService.caisseApi(this.samacaabiyoonwii, 'get_solde', this.selectedBoutique ? { idboutique: this.selectedBoutique } : {}).then(res => {
      if(res.statutreq == 1) {
        this.solde = res.data.solde;
        this.caisseType = res.data.caisse_type || 'Automatique';
        this.nbEnAttente = res.data.nb_en_attente || 0;
        this.totalEnAttente = res.data.total_en_attente || 0;
      }
    });

    this.gestockService.caisseApi(this.samacaabiyoonwii, 'get_transactions', payload).then(res => {
      if(res.statutreq == 1) {
        this.transactions = res.data;
        this.currentPage = 1;
      }
    });
  }

  /** En caisse Manuelle, seul le caissier peut valider/rejeter des transactions */
  get canValidate(): boolean {
    if (this.caisseType === 'Manuelle') {
      return this.isCaissier;
    }
    return !this.isReadOnly;
  }

  /** En caisse Manuelle, seul le caissier peut saisir des opérations de caisse manuelles */
  get canSaisir(): boolean {
    if (this.caisseType === 'Manuelle') {
      return this.isCaissier;
    }
    return !this.isReadOnly;
  }

  get filteredTransactions() {
    if (this.statutFilter === 'tous') {
      return this.transactions;
    }
    return this.transactions.filter(t => (t.statut || 'validee') === this.statutFilter);
  }

  get pendingTransactions() {
    return this.transactions.filter(t => t.statut === 'en_attente');
  }

  currentPage: number = 1;
  pageSize: number = 10;

  get paginatedTransactions() {
    const list = this.filteredTransactions;
    const start = (this.currentPage - 1) * this.pageSize;
    return list.slice(start, start + this.pageSize);
  }

  totalPages(): number {
    return Math.ceil(this.filteredTransactions.length / this.pageSize) || 1;
  }

  getPages(): number[] {
    const total = this.totalPages();
    const current = this.currentPage;
    const pages: number[] = [];
    let start = Math.max(1, current - 2);
    let end = Math.min(total, start + 4);
    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  getRangeLabel(): string {
    const list = this.filteredTransactions;
    if (list.length === 0) {
      return '0 sur 0';
    }
    const start = (this.currentPage - 1) * this.pageSize + 1;
    const end = Math.min(start + this.pageSize - 1, list.length);
    return `${start} - ${end} sur ${list.length}`;
  }

  onBoutiqueChange() {
    this.loadData();
  }

  ajouterTransaction() {
    if(this.isReadOnly) return;
    // En caisse Manuelle, seul le caissier peut saisir des opérations
    if(this.caisseType === 'Manuelle' && !this.isCaissier) {
      alert("En mode Caisse Manuelle, seul le caissier est autorisé à saisir des opérations de caisse.");
      return;
    }
    if(this.nouvelleTransaction.montant <= 0 || this.nouvelleTransaction.motif == '') {
      alert("Veuillez remplir correctement les informations.");
      return;
    }
    
    this.gestockService.caisseApi(this.samacaabiyoonwii, 'add_transaction', {
      ...this.nouvelleTransaction,
      ...(this.selectedBoutique ? { idboutique: this.selectedBoutique } : {})
    }).then(res => {
      if(res.statutreq == 1) {
        alert(this.caisseType === 'Manuelle' 
          ? "Transaction placée en attente de validation par le caissier !" 
          : "Transaction ajoutée avec succès");
        this.nouvelleTransaction.montant = 0;
        this.nouvelleTransaction.motif = '';
        this.loadData();
      } else {
        alert("Erreur lors de l'ajout: " + res.message);
      }
    });
  }

  validerTransaction(t: any) {
    if (this.isReadOnly) return;
    // En caisse Manuelle, seul le caissier peut valider
    if (this.caisseType === 'Manuelle' && !this.isCaissier) {
      alert("En mode Caisse Manuelle, seul le caissier est autorisé à valider des transactions.");
      return;
    }
    if (!confirm(`Confirmer la validation de cette transaction de ${t.montant} FCFA ?`)) return;

    this.gestockService.caisseApi(this.samacaabiyoonwii, 'validate_transaction', {
      id_transaction: t.id,
      ...(this.selectedBoutique ? { idboutique: this.selectedBoutique } : {})
    }).then(res => {
      if (res.statutreq == 1) {
        alert("Transaction validée et solde mis à jour !");
        this.loadData();
      } else {
        alert("Erreur: " + res.message);
      }
    });
  }

  rejeterTransaction(t: any) {
    if (this.isReadOnly) return;
    // En caisse Manuelle, seul le caissier peut rejeter
    if (this.caisseType === 'Manuelle' && !this.isCaissier) {
      alert("En mode Caisse Manuelle, seul le caissier est autorisé à rejeter des transactions.");
      return;
    }
    if (!confirm(`Rejeter cette transaction de ${t.montant} FCFA ?`)) return;

    this.gestockService.caisseApi(this.samacaabiyoonwii, 'reject_transaction', {
      id_transaction: t.id,
      ...(this.selectedBoutique ? { idboutique: this.selectedBoutique } : {})
    }).then(res => {
      if (res.statutreq == 1) {
        alert("Transaction rejetée.");
        this.loadData();
      } else {
        alert("Erreur: " + res.message);
      }
    });
  }

  getSourceLabel(source: string): string {
    switch (source) {
      case 'vente': return 'Vente';
      case 'recouvrement': return 'Recouvrement';
      case 'depense': return 'Dépense';
      default: return 'Opération Manuelle';
    }
  }
}
